import { TemplatePage } from './types';

const liveStreamColorBarsTheme: TemplatePage = {
  header: {
    color: '#FFE6A3',
    icon: 'images/video-templates/color_bars_theme.jpg',
    title: 'Live Stream Templates — Color Bars Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Color Bars Theme',
    description_meta:
      'Give your live stream a dazzling look with Wave.video’s color-bars-themed templates. ' +
      'Get a package of free transition screens, frames, and overlays.',
    description:
      'Create a bright and memorable design for your live streams with our color-bars-themed templates. ' +
      'Get a set of pre-designed overlays, transition screens, and frames for multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.` +
      ' Don’t hesitate to be dazzling!'
  },
  footer: {
    category: 'Live streaming color bars theme',
    description:
      'With Wave.video’s themed collections of editable overlay and transition screen templates, you will ' +
      'impress your viewers at ease! Pick an attractive set of templates and adapt it to your style with a few ' +
      'tweaks (even with no design skills). We recommend you starting with countdown, intro, lower third, technical ' +
      'issue screen to make your live streams look consistent and professional. '
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming color bars theme',
      search: { name: 'ColorBarsTheme', tags: 'ColorBarsTheme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamColorBarsTheme;
